import React from "react";
import InquiryContainer from "../containers/InquiryContainer";

export default function Inquiry() {
  return <InquiryContainer />;
}
